import { createFileRoute } from '@tanstack/react-router'
import React from 'react'

import { recipesQuery } from '@/api'
import { languagesQuery } from '@/api/languages'
import { ExpertiseLevel } from '@/features/recipes/constants'
import RecipeList from '@/features/recipes/RecipeList'
import { recipesRoute, RecipesSearch } from './recipes'

export const Route = createFileRoute('/recipes/')({
  loaderDeps: ({ search }) => ({
    ...search,
    page: search.page ?? 0,
  }),
  loader: async ({ context: { queryClient }, deps }) => {
    const [response, languages] = await Promise.all([
      queryClient.ensureQueryData(recipesQuery(deps)),
      queryClient.ensureQueryData(languagesQuery),
    ])

    return {
      totalCount: parseInt(response.headers['x-result-count']),
      data: response.data,
      languages: languages,
    }
  },
  component: RecipeListComponent,
  validateSearch: (search: Record<string, unknown>): RecipesSearch => {
    // validate and parse the search params into a typed state
    return {
      tagName: search.tagName as string[],
      authorId: search.authorId as number,
      suitableDiet: search.suitableDiet as string[],
      suitableFoodRestrictionID: search.suitableFoodRestrictionID as string[],
      cuisine: search.cuisine as string,
      expertiseLevel: search.expertiseLevel as ExpertiseLevel[],
    }
  },
})

function RecipeListComponent() {
  const { data, totalCount, languages } = Route.useLoaderData()
  const { tags } = recipesRoute.useLoaderData()

  return <RecipeList recipes={data} totalCount={totalCount} tags={tags} languages={languages} />
}
